import { Button, VideoFrame } from '../ui';

export function IntroScreen({ onStart }: { onStart: () => void }) {
  return (
    <main className="absolute inset-0 top-[84px] flex items-center justify-center gap-[114px] px-l2">
      <div className="flex w-[430px] flex-col items-start gap-m rounded-[10px] bg-white px-l py-m">
        <div className="flex w-full flex-col items-start gap-[4px]">
          <h1 className="text-[18px] font-medium leading-[23.2px] text-content">
            Google Postmaster Tools
          </h1>
          <p className="text-[12px] font-normal leading-[17.8px] text-content-muted">
            This video provides a step-by-step guide on how to link your account automatically or
            manually.
          </p>
        </div>
        <Button onClick={onStart}>Start</Button>
      </div>
      <VideoFrame />
    </main>
  );
}
